var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"complete"},[_c('h1',[_vm._v("Oops!")]),_c('p',[_vm._v(" You did not finish your payment, please try again. ")])])}]

export { render, staticRenderFns }